<template>
	<div class="model_mid">
		<div class="mid_left">
			<h3>萌芽、展叶、新梢生长期内环境监测及水肥灌溉情况</h3>
			<div class="mid_left_table_title">
				<div class="title_item" :class="{ title_item_active: activeIndex === 0 }" @click="addActive(0)">
					气象监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 1 }" @click="addActive(1)">
					土壤监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 2 }" @click="addActive(2)">
					水肥灌溉记录
				</div>
			</div>
			<wearth v-if="activeIndex===0" />
			<roil v-if="activeIndex===1" />
		    <fertilizer v-if="activeIndex===2"/>
		</div>
		<div class="mid_img">
			<img src="@/assets/period/3.png" alt="" />
		</div>
		<div class="mid_right">
			<div class="back_title"></div>
			<div class="agricultural_boder">
				<div class="agricultural">
					病虫害预防：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						4 月喷 25% 阿米西达 （嘧菌酯） 1000 倍 +10% 世高（苯醚甲环唑） 1 000 倍 +10 % 吡虫啉 1 000 倍液 1 次，15天后再喷 1 次。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-4-1
					</div>
					<div class="agricultural_tcontent_right">
						已提醒
					</div>
				</div>
				<div class="agricultural">
					抹芽：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						抹除主干、主蔓上多余的芽，每个节位选留 1 个健壮饱满芽即可。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-4-11
					</div>
					<div class="agricultural_tcontent_right">
						已提醒
					</div>
				</div>
				<div class="agricultural">
					定梢：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						一般每个节位保留 1 个新梢，抹除多余新梢，保留生长一致的中庸梢。每亩 留梢量 3000~3500 个。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-4-20
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				
				<div class="agricultural">
					花前肥：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						开花前 7天（ 5 月 3 日左右） 每亩施氮、磷、钾含量均为 17% 的复合肥 20~30kg 。 同时，叶面喷施 0.2％ 磷酸二氢钾 3 次（每 10 d 喷 1 次），促进新梢木质化，方便绑缚，促进开花坐果。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-5-1
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="agricultural">
					幼苗管理：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						幼苗顶端新梢沿着竖立于苗旁的竹竿引缚上架，副梢留 2 叶摘心。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-5-1
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="divider"></div>
			</div>
			<div class="control">
				<p>
					<sapn class="diseases">主要病虫害:</sapn>
					<sapn class="diseases_text">
						灰霉病、霜霉病、黑痘病、穗轴褐枯病、绿盲蝽、斑衣蜡蝉、金龟子等
					</sapn>
				</p>
				<p>
					<span class="Prevention">防治措施:</span>
					<span
						class="Prevention_text">
						50%异菌脲悬浮剂1 000 倍液+50%烯酰吗啉2 000 倍液+10%烯啶虫胺可溶液剂3 000 倍液（灰霉病、霜霉病、绿盲蝽、斑衣蜡蝉）；或250 克/升吡唑醚菌酯乳油2 000 倍液+10%烯啶虫胺可溶液剂3 000 倍液（霜霉病、灰霉病、黑痘病、绿盲蝽、斑衣蜡蝉为主）。注意霜霉病、灰霉病情况，若有霜霉病发生可改烯酰吗啉、吡唑醚菌酯为68.75%氟菌·霜霉威（银法利）1 000 倍液，该药可被根吸收并在植物体内上下传导、跨层传导。
					</span>
				</p>
		
			</div>
		
		</div>
		
	</div>
	<div class="model_content">
		<div class="model_content_title">萌芽·展叶·新梢生长期</div>
		<div class="model_content_date">4-1 至 5-10</div>
		<div class="model_content_text">
			这个阶段，阳光玫瑰葡萄开始萌芽，长出新叶和新梢。新叶的展开发绿意盎然，植物进入快速生长期。这时需要注意病虫害的防治和充足的水肥供应，以促进健康生长。
			
		</div>
	</div>
	
</template>

<script setup>
	import {
		ref
	} from 'vue';
	import wearth from './wearth/index.vue';
	import roil from './roil/index.vue';
	import fertilizer from './fertilizer/index.vue';

	let activeIndex = ref(0);

	function addActive(e) {
		activeIndex.value = e;
	}
</script>

<style lang="scss" scoped>
	.model_mid {
		width: 1840px;
		margin: 0 auto;
		height: 660px;
		background-image: url('../../../assets/model/mid-boder.png');
		background-size: 100% 100%;
		margin-top: 100px;
		display: flex;
		.mid_left {
				width: 660px;
				height: 540px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/mid-left.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				h3 {
					margin-left: 40px;
					color: #2dffd0;
				}
		
				.mid_left_table_title {
					width: 60%;
					display: flex;
					font-size: 14px;
					margin: 0 auto;
					margin-top: 20px;
					justify-content: space-between;
					color: #00a580;
		
					.title_item {
						flex: 1;
						text-align: center;
						padding: 5px;
					}
		
					.title_item_active {
						background-image: url('@/assets/model/mid-left-button.png');
						color: white;
						background-size: 100% 100%;
					}
				}
		
		
		
			}
		
			.mid_img {
				margin-left: 30px;
				margin-top: 200px;
			}
		
			.mid_right {
				padding: 20px;
				width: 660px;
				height: 550px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/smallboder.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				.back_title {
					height: 28px;
					width: 620px;
					background-image: url("@/assets/model/smalltitle.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
		
				.agricultural_boder {
					font-size: 12px;
					.agricultural {
						color: #72a39f;
						margin-top: 8px;
						margin-left: 15px;
					}
		
					.agricultural_tcontent {
						width: 620px;
						display: flex;
						color: #007e62;
						margin-top: 10px;
						align-items: center;
						/* 垂直居中 */
						justify-content: space-between;
						/* 水平两端对齐 */
						padding-left: 15px;
		
						.agricultural_tcontent_left {
							text-align: justify;
							width: 380px;
						}
		
					}
		
					.divider {
						height: 2px;
						width: 100%;
						margin-top: 20px;
						background: linear-gradient(to right, transparent, #00796B, transparent);
					}
				}
		
				.control {
					color: white;
					margin-top: 10px;
					width: 100%;
					padding-left: 15px;
					text-align: justify;
					font-size: 14px;
		
		
					p {
						display: flex;
						justify-content: flex-start;
						padding-top: 15px;
					}
		
					.diseases {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
		
					}
		
					.diseases_text {
						display: inline-block;
						width: 520px;
						line-height: 20px;
						color: #007e62;
						padding-left: 20px;
					}
		
					.Prevention {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
					}
		
					.Prevention_text {
						display: inline-block;
						width: 520px;
						color: #007e62;
						line-height: 20px;
						padding-left: 20px;
					}
		
		
		
				}
		
			}

	}
	
	.model_content {
		width: 685px;
		height: 100px;
		margin: 0px auto;
		text-align: center;
		color: white;
		margin-top: -60px;
	
		.model_content_title {
			color: #23c9a4;
			font-size: 18px;
			font-weight: bold;
		}
	
		.model_content_date {
			margin-top: 10px;
			color: white;
			font-size: 16px;
			color: #23c9a4;
			font-weight: bold;
		}
	
		.model_content_text {
			margin-top: 10px;
			color: #23c9a4;
		}
	}
	
	
</style>